import { FEATURE_TYPE_CODE } from "@/v2-backoffice-client/feature/feature.constants"
import { getBasemapSheetHref } from "@/v2-backoffice-client/basemap/basemap.constants"
import { getLayerSheetHref } from "@/v2-backoffice-client/layer/layer.constants"
import type { ConfigurationOwner } from "@/v2-backoffice-client/feature/configuration/feature.configuration.types"

/**
 * Monaco's JSON schemas are registered globally, once per language, so an
 * editor is bound to its schema through its MODEL URI: the editor mounts
 * with a `path` built from this base and the schema's `fileMatch` targets
 * exactly that URI.
 *
 * All three catalogs (map layers, basemaps, nav layers) share the one
 * registry, so they must build their paths from one base or a name
 * collision would silently hand an editor the wrong schema.
 */
const MODEL_URI_BASE = "placepoint://catalog-editor/"

/** The model URI a document named `modelName` is edited under. */
export function getCatalogEditorModelPath(modelName: string): string {
  return MODEL_URI_BASE + modelName
}

/**
 * The catalogs that keep their Configuration somewhere other than the
 * feature row: a basemap's is on gis.Basemaps and a map layer's on
 * gis.Layers, each with a purpose-built editor behind its own sheet.
 *
 * A generic feature editor pointed at common.Features.Configuration would
 * write a column nothing reads for these, so every surface that could offer
 * one looks here first and links out instead.
 */
export const CONFIGURATION_OWNER_BY_FEATURE_TYPE: Record<
  number,
  ConfigurationOwner
> = {
  [FEATURE_TYPE_CODE.basemap]: {
    label: "basemap",
    getHref: getBasemapSheetHref,
  },
  [FEATURE_TYPE_CODE.mapLayer]: {
    label: "map layer",
    getHref: getLayerSheetHref,
  },
}
